import axios from 'axios'
import { trackApiError } from '@/common/js/omega'
// import { v4 as uuidv4 } from 'uuid/dist/esm-browser'
// import md5 from 'blueimp-md5'
let Http = axios.create({
  withCredentials: true,
  headers: {
    post: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    get: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    put: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    delete: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  }
});

// Add a request interceptor
Http.interceptors.request.use(config => {
  // 跨国统一添加/cross前缀
  config.url = '/cross' + config.url
  return config
}, function (error) {
	// Do something with request error
  trackApiError({
    api: error?.config?.url,
    code: error?.code || 0
  });
	console.log(error)
	return Promise.reject(error);
})

// Add a response interceptor
Http.interceptors.response.use((response) => {
	return response.data;
}, function (error) {
  trackApiError({
    api: error?.config?.url || error?.url,
    status: error?.response?.status,
    code: error?.code,
    attr: error?.message
  });
  let data;
  if (error.response) {
    data = error.response
  }else if(error.request) {
    data = error.request
  }
  // if error.message 为Network Error，大概率是跨域问题,也可能是服务器500+
  // trackDiyError({
  //   tagName: 'ajax_error',
  //   info: 'api_error; ' + error.message,
  //   data: Object.assign(data, error.toJSON())
  // })
  
  return Promise.reject(error);
});

export default Http